import { type Descendant, Element } from 'slate';

import { randomUUID } from 'js/lib/uuid';

import { BLOCK_TYPES } from 'bundles/cml/shared/constants';
import type { CodeElement } from 'bundles/cml/shared/types/elementTypes';

const normalizeCodeBlock = (node: CodeElement): CodeElement => {
  return {
    ...node,
    id: randomUUID(),
    // interactive code blocks should not be copyable because they require
    // additional configuration setup on the BE to work correctly
    // see AUTHORING-8488 for more detail
    evaluatorId: undefined,
  };
};

export const normalizeFragments = (fragments: Descendant[]): Descendant[] => {
  return fragments.map((node) => {
    if (Element.isElement(node) && node.type === BLOCK_TYPES.CODE) {
      return normalizeCodeBlock(node);
    }

    return node;
  });
};
